import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_82b151a0: FaireBrandEntity = {
  token: "b_82b151a0",
  type: "brand",
  name: "BYRD Hairdo Products",
  avatarUrl:
    "https://cdn.faire.com/fastly/f7e095fb467f25151d4b46fddfe92f856dcd6808d42b1359e14ea38caf09c5c6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c952a73bbdc16e17faef854a54a921632c4754f4c7cf43babcf0eb9bb1dcc79b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f7e095fb467f25151d4b46fddfe92f856dcd6808d42b1359e14ea38caf09c5c6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c952a73bbdc16e17faef854a54a921632c4754f4c7cf43babcf0eb9bb1dcc79b.jpeg",
  location: "Newport Beach, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "INSPIRED BY THE \"GENTLEMAN SURFER\", BYRD PRODUCTS HARKEN BACK TO AN ERA WHEN GROOMING WAS AN ESSENTIAL PART OF ONE'S DAILY ROUTINE WITH A NOD TO CLASSIC 60'S SURF CULTURE.\n\nAt BYRD, we draw a ton of inspiration from Californian culture and the surfing lifestyle of the ‘50s and ‘60s. Growing up in Newport Beach, surfing has always been a huge part of my life.\nAnd as a surfer, there’s nothing I know better than sun, salt and surf. Which also happen to be the three key ingredients for healthy hair and skin. That’s why we use them in our products.\nWe come up with all of our product ideas here at the BYRD’s Nest in sunny Newport Beach, California. This is where we eat, sleep, surf and stay slick. Inspired by the gentleman surfer, we don't let our lifestyle get in the way; we let it pave the way.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:54.082Z",
    importedBy: "entity-db-cli",
  },
};
